import Vue from 'vue'
import App from './App.vue'
import createRouter from './router/router'
import '@/assets/css/common/reset.scss'
import NProgress from 'nprogress'
import '@/icons'
import Mask from '@/components/Mask'
import toast from '@/components/toast/main'
import store from '@/store'
import '@/assets/js/rem'
import axios from 'axios'
import wxConfig from './utils/wx.jsapi'
import VueClipboard from 'vue-clipboard2'
import { Swipe, SwipeItem, Loading, Popup, Dialog } from 'vant'
import 'vant/lib/index.css'
import FloatBall from '@/components/FloatBall'

Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Loading)
Vue.use(VueClipboard)
Vue.use(Popup)
Vue.use(Dialog)

Vue.component('floatBall', FloatBall)
Vue.config.productionTip = false

Vue.component('mask-pop', Mask)
// 封装全局 toast
Vue.prototype.$toast = toast
// 微信分享
Vue.prototype.wxConfig = wxConfig
// 全局注册，使用方法为:this.$axios
Vue.prototype.$axios = axios

const router = createRouter()

// 路由钩子函数
router.beforeEach((to, from, next) => {
  // 加载进度条
  NProgress.start()
  // 路由发生变化时修改 title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
